import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {openInBrowser} from '../../../srcCommon/browser/openInBrowser';
import {emojiMap} from '../../services/emojis/emojis';
import {InlineEmoji} from '../common/emoji/inlineEmoji';

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: 12px;
  justify-items: center;
  padding: 0 30px;
`;

const StyledTitleDiv = styled.div`
  font-size: 32px;
  font-weight: ${fontWeights.bold};
  text-align: center;
`;

const StyledDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.large};
  line-height: 26px;
  text-align: center;
  max-width: 270px;
`;

const StyledButtonDiv = styled.div`
  margin-top: 12px;
  border-radius: 14px;
  overflow: hidden;
  ${(p) => boxShadow(p.theme, `0px 3px 14px rgba(26, 76, 168, 0.2)`)};
  & [role='button'] > div {
    transition: background-color 250ms ease-out;
  }
`;

const StyledButtonContentDiv = styled.div`
  padding: 0px 40px;
`;

/*
 * Component.
 */

export const VisitorViewerSidebarContentTryFront: FC = () => (
  <StyledContentDiv>
    <StyledTitleDiv>
      <Trans id="visitor-sidebar-title">
        <InlineEmoji emoji={emojiMap['star-struck']} size={32} /> Like what you see?
      </Trans>
    </StyledTitleDiv>
    <StyledDescriptionDiv>
      <Trans id="visitor-sidebar-description-tryfront">
        Front is reinventing email for the way teams work. It transforms your inbox into the place you get
        work done — together.
      </Trans>
    </StyledDescriptionDiv>
    <StyledButtonDiv>
      <Button onClick={onTryFrontClick} size={VisualSizesEnum.LARGE} variant={ButtonVariantsEnum.PRIMARY}>
        <StyledButtonContentDiv>
          <Trans id="visitor-sidebar-button">Try Front for free</Trans>
        </StyledButtonContentDiv>
      </Button>
    </StyledButtonDiv>
  </StyledContentDiv>
);

/*
 * Event handlers.
 */

function onTryFrontClick() {
  openInBrowser('https://frontapp.com/signup?utm_source=front&utm_campaign=share_thread_p3');
}
